import Vue from 'vue';
import lodash from 'lodash';

// Vue.$_ = Vue.prototype.$_ = lodash;
Vue.$_ = {
  get: lodash.get,
  cloneDeep: lodash.cloneDeep,
  debounce: lodash.debounce
}

Vue.prototype.$_ = {
  get: lodash.get,
  cloneDeep: lodash.cloneDeep,
  debounce: lodash.debounce
}
